var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"mr-0 mt-2",attrs:{"loading":_vm.isLoading,"color":"error darken-4 white--text","rounded":""},on:{"click":function($event){return _vm.exportKonversiNilai('tahun')}}},[_c('span',[_c('v-icon',{attrs:{"small":"","left":""}},[_vm._v("mdi-file-pdf-box")]),_vm._v(" Download Konversi Nilai Angka Kredit ")],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }